export default __webpack_public_path__ + "static/media/ava4.64c3bda5.png";